import { Component, Input } from '@angular/core';

import { TaskFeasibilityInfo } from 'planner-shared';

@Component({
    selector: 'app-employee-task-feasibility-info',
    templateUrl: './employee-task-feasibility-info.component.html',
    standalone: false
})
export class EmployeeTaskFeasibilityInfoComponent {
    @Input() public feasibilityInfo: TaskFeasibilityInfo;
}
